import { isMobile } from "react-device-detect";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";

export default function Footer() {
  const { language } = useLanguage();
  const t = translations[language];

  if (!isMobile) {
    // Desktop Footer
    return (
      <footer className="bg-gray-800 text-white">
        {/* Top section with links */}
        {/* Removed for now as it provides no value */}
        {/* <div className="bg-gray-700 py-8">
          <div className="max-w-7xl mx-auto px-4">
            <nav aria-labelledby="cdts-appFooterLinks">
              <h2 className="wb-inv" id="cdts-appFooterLinks">
                {t.relatedLinks}
              </h2>
              <ul className="grid grid-cols-2 md:grid-cols-2 gap-4 list-none">
                <li>
                  <a
                    href="/support"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.defenceTeamCareersSupport}
                  </a>
                </li>
                <li>
                  <a
                    href="/report-issue"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.reportAnIssue}
                  </a>
                </li>
                <li>
                  <a
                    href="/about-us"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.aboutUs}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.termsOfUseJobSeekers}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.termsOfUseEmployers}
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div> */}

        {/* Bottom section with Canada wordmark */}
        <div className="bg-gray-200 py-4">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <nav className="mb-4 md:mb-0" aria-labelledby="aboutWebApp">
                <h3 className="wb-inv" id="aboutWebApp">
                  {t.governmentOfCanadaCorporate}
                </h3>
                <ul className="flex flex-wrap items-center gap-2 list-none text-gray-800 text-sm">
                  <li>
                    <a
                      href={t.termsAndConditionsUrl}
                      className="text-gray-800 hover:underline visited:text-gray-800"
                    >
                      {t.termsAndConditions}
                    </a>
                  </li>
                  <li className="text-gray-900">•</li>
                  <li>
                    <a
                      href={t.privacyUrl}
                      className="text-gray-800 hover:underline visited:text-gray-800"
                    >
                      {t.privacy}
                    </a>
                  </li>
                </ul>
              </nav>
              <div>
                <img
                  src="https://www.canada.ca/etc/designs/canada/wet-boew/assets/wmms-blk.svg"
                  alt={t.governmentOfCanadaSymbolAlt}
                  style={{ height: "40px", width: "auto" }}
                />
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  } else {
    // Mobile Footer
    return (
      <footer className="bg-gray-800 text-white mt-8">
        {/* Top section with links */}
        {/* Removed for now as it provides no value */}
        {/* <div className="bg-gray-700 py-6">
          <div className="max-w-7xl mx-auto px-4">
            <nav aria-labelledby="cdts-appFooterLinksMobile">
              <h2 className="wb-inv" id="cdts-appFooterLinksMobile">
                {t.relatedLinks}
              </h2>
              <ul className="grid grid-cols-1 gap-4 list-none">
                <li>
                  <a
                    href="/support"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.defenceTeamCareersSupport}
                  </a>
                </li>
                <li>
                  <a
                    href="/report-issue"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.reportAnIssue}
                  </a>
                </li>
                <li>
                  <a
                    href="/about-us"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.aboutUs}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.termsOfUseJobSeekers}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:underline visited:text-white"
                  >
                    {t.termsOfUseEmployers}
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div> */}

        {/* Bottom section with Canada wordmark */}
        <div className="bg-gray-200 py-4">
          <div className="max-w-7xl mx-auto px-4">
            <nav aria-labelledby="aboutWebAppMobile">
              <h3 className="wb-inv" id="aboutWebAppMobile">
                {t.governmentOfCanadaCorporate}
              </h3>
              <ul className="flex flex-col space-y-2 list-none text-gray-800 text-xs mb-3">
                <li>
                  <a
                    href={t.termsAndConditionsUrl}
                    className="text-gray-800 hover:underline visited:text-gray-800"
                  >
                    {t.termsAndConditions}
                  </a>
                </li>
                <li>
                  <a
                    href={t.privacyUrl}
                    className="text-gray-800 hover:underline visited:text-gray-800"
                  >
                    {t.privacy}
                  </a>
                </li>
              </ul>
            </nav>
            <div className="flex justify-end">
              <img
                src="https://www.canada.ca/etc/designs/canada/wet-boew/assets/wmms-blk.svg"
                alt={t.governmentOfCanadaSymbolAlt}
                style={{ height: "30px", width: "auto" }}
              />
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
